import React from 'react';

const StoryScene = ({ scene, sceneNumber, onChoice, loading, isFinalScene, selectedRole }) => {
  console.log("StoryScene props:", { scene, sceneNumber, loading, isFinalScene, selectedRole });
  
  // Helper function to render text with proper paragraph breaks
  const renderText = (text) => {
    return text.split('\n').map((paragraph, index) => {
      if (!paragraph.trim()) {
        return null;
      }
      return <p key={index}>{paragraph}</p>;
    });
  };

  // Handle loading state
  if (loading) {
    // If we're loading the first scene, show Scene 1
    // Otherwise, show the next scene number
    const displayNumber = scene ? sceneNumber + 1 : 1;
    
    return (
      <div className="card">
        <div className="scene-number">Scene {displayNumber}</div>
        <div className="loading">
          <div className="pulse">Generating your story...</div>
          {/* Loading spinner is added via CSS ::after */}
        </div>
      </div>
    );
  }

  // Handle missing scene data
  if (!scene) {
    console.error("Missing scene data in StoryScene component");
    
    // Provide a fallback scene based on the selected role
    const roleName = selectedRole?.name || "adventurer";
    const roleDesc = selectedRole?.description || "exploring this future world";
    
    return (
      <div className="card">
        <div className="scene-number">Scene {sceneNumber}</div>
        <div className="scene-text">
          {renderText(`As a ${roleName}, you begin your journey in the world of 2035.\n\n${roleDesc}\n\nWhat would you like to do first?`)}
        </div>
        {[
          "Explore my surroundings",
          "Connect with other people",
          "Focus on my primary responsibilities"
        ].map((choice, index) => (
          <button 
            key={index}
            className="choice-btn" 
            onClick={() => onChoice(choice)}
          >
            {choice}
          </button>
        ))}
      </div>
    );
  }

  // Default choices if none are provided
  const defaultChoices = [
    "Continue your adventure",
    "Take a different approach",
    "Consider your options carefully"
  ];

  // Extract choices safely
  const choices = scene.choices && Array.isArray(scene.choices) && scene.choices.length > 0
    ? scene.choices
    : defaultChoices;

  return (
    <div className="card">
      <div className="scene-number">Scene {sceneNumber}</div>
      <div className="scene-text">
        {renderText(scene.text || "Your adventure continues...")}
      </div>
      
      {!isFinalScene && choices.map((choice, index) => (
        <button 
          key={index} 
          className="choice-btn" 
          onClick={() => onChoice(choice)}
        >
          {choice.split('\n').map((line, lineIndex, lineArray) => (
            <React.Fragment key={lineIndex}>
              {line}
              {lineIndex < lineArray.length - 1 && <br />}
            </React.Fragment>
          ))}
        </button>
      ))}
      
      {isFinalScene && (
        <div style={{ marginTop: '2rem' }}>
          <p style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>
            Your journey in this future has reached its conclusion.
          </p>
          <button 
            className="choice-btn" 
            onClick={() => onChoice("Continue to end screen")}
          >
            See your story summary
          </button>
        </div>
      )}
    </div>
  );
};

export default StoryScene;